import React from 'react'
import DownloadOurAppSection from '../../sections/DownloadOurAppSection'
import { MobileAppSectionSliceProps } from './types'

const MobileAppSectionSlice: React.FC<MobileAppSectionSliceProps> = ({ slice }) => {
  const { image, video, title, description } = slice.primary || {}

  return (
    <DownloadOurAppSection
      inner="inners.primary"
      paddingTop={['40px', '', '50px']}
      paddingBottom={['60px', '', '200px']}
      data={{
        media: {
          image: {
            publicURL: image?.url,
            childImageSharp: image && {
              gatsbyImageData: image.gatsbyImageData
            },
            width: image?.dimensions?.width,
            height: image?.dimensions?.height,
            alt: image?.alt
          },
          video
        },
        content: {
          title: title?.text || '',
          subtitle: description?.text
        },
        buttons: slice.items?.map((item, index) => {
          const { button_text = '', button_icon, button_link } = item || {}

          return {
            key: index,
            url: button_link?.url,
            urlText: button_text,
            urlIsExternal: true,
            label: button_icon
          }
        })
      }}
    />
  )
}

export default MobileAppSectionSlice
